/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { RoadDirection } from '../models/road-details.interface';

/**
 * Determines if adding a new segment would create a direction conflict.
 * A conflict exists when mixing one-way (forward/backward) with two-way (both),
 * or when mixing opposite one-way directions (forward with backward).
 *
 * @param existingDirection - The direction of the current selection (or first segment)
 * @param newDirection - The direction of the segment being added
 * @returns true if a conflict exists, false otherwise
 */
export function hasDirectionConflict(existingDirection: RoadDirection, newDirection: RoadDirection): boolean {
  return existingDirection !== newDirection;
}
